/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback, useEffect, useContext, useState, useRef } from 'react';

import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { useModal } from '@jutro/components';
import { QuestionSetComponent, platformMessages, FormModalPopover } from 'ml-components-platform-react';
import { LoadSaveService } from 'gw-capability-quoteandbind';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import '@xengage/gw-platform-translations';
import _ from 'lodash';
import appConfig from 'app-config';
import { MLLocalDateUtil, convertToSentenceCase } from 'ml-portals-util-js';
import HOTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/HOTrackEvent';

import { MLDriverVehicleUtil, MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import {
    PriorInsuranceComponent,
    PriorMetSubmissionPopup,
    PriorMetSubmissionPopupMessages,
    PriorMetSubmissionPopupStyles
} from 'ml-capability-quoteandbind-common-react';

import messages from './HOAdditionalInfoToQuote.messages';

import metadata from './HOAdditionalInfoToQuote.metadata.json5';
import styles from './HOAdditionalInfoToQuote.module.scss';
import { ScrollToError } from '@jutro/legacy/wizard-next';

import { IntlContext } from '@jutro/legacy/locale';

const questionsToHide = ['HOPOccupationType_Ext', 'HOPEducationLevel_ML', 'HOPCoverageAdditionalInfo_ML', 'HOPHasAnimal_ML'];

const _filterQuestionSet = (qs) => {
    qs.answers = Object.keys(qs.answers)
        .filter((key) => !questionsToHide.includes(key))
        .reduce((obj, key) => {
            obj[key] = qs.answers[key];
            return obj;
        }, {});
};
const filterAnimalQuestions = (qs, patterns = []) => {
   if (!qs?.answers) return qs;

   qs.answers = Object.keys(qs.answers)
       .filter(key => !patterns.some(pattern => key.includes(pattern)))
       .reduce((obj, key) => {
           obj[key] = qs.answers[key];
           return obj;
       }, {});

   return qs;
};

// ML: MLHOAddtlInfoToQuoteCtrl.js, ml-ho-addtl-info-to-quote.html

function HOAdditionalInfoToQuote(props) {
    const modalApi = useModal();
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const { refreshData } = useDataRefresh();
    const { authHeader } = useAuthentication();

    const {
        wizardData: submissionVM, updateWizardData, goNext, currentStep, isSkipping
    } = props;

    const { onValidate, isComponentValid } = useValidation('HOAdditionalInfoToQuote');
    const [showErrors, setShowErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [priorInsuranceErrors_Ext, setPriorInsuranceErrors_Ext] = useState([]);
    const [showPriorInsuranceErrors_Ext, setShowPriorInsuranceErrors_Ext] = useState(false);
    
    const { nextStepVisited } = MLWizardNavUtil(props);

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        getFullName,
    } = MLDriverVehicleUtil(viewModelService);

    const {
        clearBlockAlerts,
        addWarningAlert,
        getNumberOfAlerts,
        clearWarningAlerts,
        addErrorAlert
    } = MLNotificationBlockUtil();

    const LOSSTYPE_DESCRIPTION_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('LossType_ML');

    // init
    const quoteID = submissionVM.quoteID.value;
    const hoModel = submissionVM.lobData.homeowners.value;

    const isQnb = appConfig.portalCode === 'QB';

    const initDisclosures = () => {
        if (!hoModel.coverables.disclosures_ML) {
            hoModel.coverables.disclosures_ML = { losses: [] };
        }
    };

    initDisclosures();

    const [isPrefillDisclosures] = useState(() => { return hoModel.coverables.disclosures_ML.losses.length > 0; });
    const [recentlyAddedClaim, setRecentlyAddedClaim] = useState({});
    const [showClaimButton, setShowClaimButton] = useState(true);
    const [maxClaimDate, setMaxClaimDate] = useState({});

    useEffect(() => {
        if (!isSkipping) {
            HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, null, { step: 'HO Additional Info Page' }, true);
        }
    }, [])

    const priorInsuranceQuestionSetData = _.get(submissionVM.lobData.homeowners, 'priorInsurance.value[0]');
    if (priorInsuranceQuestionSetData) {
        _filterQuestionSet(priorInsuranceQuestionSetData);
    }

    useEffect(() => {
        clearBlockAlerts('priorInsuranceErrors');
        if(!isQnb) return;
        if (showPriorInsuranceErrors_Ext === true) {
            priorInsuranceErrors_Ext.forEach((error) => {
                addErrorAlert(error, 'priorInsuranceErrors');
                window.scrollTo(0, 0);
            });
        }
    }, [showPriorInsuranceErrors_Ext])

    const dwellingInfoQuestionSetData = _.get(submissionVM.lobData.homeowners, 'dwellingAdditionalInfo.value[0]');
    const filteredDwellingInfoQuestionSetData = _.clone(dwellingInfoQuestionSetData);
    if (filteredDwellingInfoQuestionSetData) {
        _filterQuestionSet(filteredDwellingInfoQuestionSetData);
       filterAnimalQuestions(filteredDwellingInfoQuestionSetData, [
    'HOPHasExoticAnimal',
    'HOPHasDog',
    'HOPDogBirthYear',
    'HOPDogBreed',
    'HOPDogMarkingsTattoo',
    'HOPDogName',
    'HOPExoticAnimalBirthYear',
    'HOPExoticAnimalMarkingsTattoo',
    'HOPExoticAnimalName',
    'HOPExoticAnimalType',
    'HOPHasFarmAnimals',
    'HOPHasOtherAnimals'
]);
    }

    const syncPriorInsuranceQuestionSets = useCallback(() => {
        // const scrollPositionBeforeUpdate = window.pageYOffset;
        const syncPromise = LoadSaveService.syncQuestionSetML(quoteID, [priorInsuranceQuestionSetData]);
        showProgressDialog(platformMessages.syncingQuestions, syncPromise, true);
        // const numberAlertsBeforeUpdate = alertHelper.getNumberOfAlertsInAlertGroup();
        syncPromise.then((updatedQuestionSets) => {
            const priorInsuranceQs = updatedQuestionSets.find((q) => q.code === 'PriorInsuranceMultiLine_Ext');
            _.set(submissionVM, 'lobData.homeowners.priorInsurance.value[0]', priorInsuranceQs);
            // setTimeout(() => {
            //     const numberAlertsAfterUpdate = alertHelper.getNumberOfAlertsInAlertGroup();
            //     if (!(numberAlertsAfterUpdate > numberAlertsBeforeUpdate)) {
            //         // If no alerts have been added we want to scroll back to the position the user was at before the Question Set update
            //         // as the height of the container containing the Question Set may change. If an alert has been added
            //         // we wish to scroll to the top of the screen - this will happen automatically when addAlert() is called in MLAlertService
            //         window.scrollTo(0, scrollPositionBeforeUpdate);
            //     }
            // });
            refreshData();
        });
    }, [authHeader, priorInsuranceQuestionSetData, quoteID, refreshData, showProgressDialog, submissionVM]);

    const syncDwellingInfoQuestionSets = (qsQuestionType) => {
        // const scrollPositionBeforeUpdate = window.pageYOffset;
        const syncPromise = LoadSaveService.syncQuestionSetML(quoteID, [filteredDwellingInfoQuestionSetData]);
        if (qsQuestionType !== "Choice" && qsQuestionType !== "Integer") {
            showProgressDialog(platformMessages.syncingQuestions, syncPromise, true);
        }
        // const numberAlertsBeforeUpdate = alertHelper.getNumberOfAlertsInAlertGroup();
        syncPromise.then((updatedQuestionSets) => {
            const dwellingQs = updatedQuestionSets.find((q) => q.code === 'HOPDwellingAddlInfo_ML');
            _.set(submissionVM, 'lobData.homeowners.dwellingAdditionalInfo.value[0]', dwellingQs);
            // setTimeout(() => {
            //     const numberAlertsAfterUpdate = alertHelper.getNumberOfAlertsInAlertGroup();
            //     if (!(numberAlertsAfterUpdate > numberAlertsBeforeUpdate)) {
            //         // If no alerts have been added we want to scroll back to the position the user was at before the Question Set update
            //         // as the height of the container containing the Question Set may change. If an alert has been added
            //         // we wish to scroll to the top of the screen - this will happen automatically when addAlert() is called in MLAlertService
            //         window.scrollTo(0, scrollPositionBeforeUpdate);
            //     }
            // });
            refreshData();
        });
    };

    // claim
    const _createLossVMWithDefaultValues = () => {
        const lossVM = viewModelService.create(recentlyAddedClaim, 'pc', 'metlife.edge.capabilities.policycommon.disclosures.dto.LossDTOML');
        lossVM.source.value = 'customer_disclosed';
        lossVM.paidAmount.value = {
            amount: 0,
            currency: 'usd'
        };
        return lossVM;
    };

    const onAddClaim = () => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add Claim`);
        setRecentlyAddedClaim(_createLossVMWithDefaultValues());
        setShowClaimButton(false);
        setMaxClaimDate(MLLocalDateUtil.date2LocalDate(new Date()));
        maxClaimDate.day -= 1;
    };

    const onCancelAddClaim = () => {
        setRecentlyAddedClaim({});
        setShowClaimButton(true);
        setShowErrors(false);
    };

    const onSaveClaim = () => {
        if (recentlyAddedClaim.aspects.valid && recentlyAddedClaim.aspects.subtreeValid) {
            const newClaim = recentlyAddedClaim.value;
            hoModel.coverables.disclosures_ML.losses.push(newClaim);
            setRecentlyAddedClaim({});
            setShowClaimButton(true);
            MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_Add Claim`);
        } else {
            setShowErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
        }
    };

    const formatAvailableValues = (viewModel) => {
        if (!viewModel) return [];
        return viewModel.aspects.availableValues.map((availableValue) => ({
            code: availableValue.code,
            name: translator({
                id: availableValue.name,
                defaultMessage: availableValue.name
            })
        }));
    };

    const intl = useContext(IntlContext);
    const getFormattedDateString = (gwDateVal) => {
        const date = LocalDateUtil.toMidnightDate(gwDateVal);
        return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' });
    };

    const isCustomerDisclosure = (disc) => {
        return disc.source === 'customer_disclosed';
    };

    const showNameField = () => {
        return hoModel.coverables.disclosures_ML.losses.some((c) => c.nameInsured);
    };

    const onDeleteClaim = (evt) => {
        if (evt.index >= 0) {
            hoModel.coverables.disclosures_ML.losses.splice(evt.index, 1);
        }
        refreshData();
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Remove Claim`);
    };

    // wizard page
    const onChangeTypes = ['Boolean', 'Choice', 'Integer'];
    const onDwellingQuestionValueChange = (aQuestionSetAnswersValue, pathToAnswers, qsQuestionType) => {
        if (onChangeTypes.includes(qsQuestionType)) {
            // RadioButton has no onBlur event
            syncDwellingInfoQuestionSets(qsQuestionType);
        } else {
            // use onBlur for other Input fields
            _.set(submissionVM, 'lobData.homeowners.dwellingAdditionalInfo.value[0]', aQuestionSetAnswersValue);
            refreshData();
        }
    };

    const onBlurDwelling = (evt, object, qsQuestionType) => {
        if (!onChangeTypes.includes(qsQuestionType)) {
            // DropdownField component triggers onBlur event but syncQuestionSet should be performed in onValueChange
            syncDwellingInfoQuestionSets(qsQuestionType);
        }
    };

    const isPriorInsuranceMetOrFarmers = () => {
        const answers = _.get(priorInsuranceQuestionSetData, "answers.MultLineCurrentInsuranceProvider_Ext");
        return (answers === 'MultLineCurrentInsuranceProviderFarmers_Ext' || answers === 'MultLineCurrentInsuranceProviderMetLifePropCas_Ext');
    };


    const saveAndQuote = async (calledFromPopUp = false) => {
        HOTrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'HO Additional Info Page', action: 'HO Additional Page Submitted' }, true);

        if (!submissionVM.isSubmitAgent.value) {
            clearWarningAlerts()
            // For GPA, SkipSave and goto hoDisclosureToQuote page
            _.unset(submissionVM.value, 'bindData');
            showProgressDialog(platformMessages.saveAndQuoteSubmission);
            try {
                submissionVM.value = await LoadSaveService.saveAndQuoteSubmission(submissionVM.value, authHeader);
                MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails');

                const warningMsgs = submissionVM.value.lobData.homeowners.warnings
                let ignoreInsurviewWarning = true;
                if (warningMsgs != null && warningMsgs.length > 0) {
                    warningMsgs.forEach((value) => {
                        if (value !== " " && value !== null) {
                            addWarningAlert(value, 'InsurviewWarning');
                            ignoreInsurviewWarning = false;
                        }
                    })
                    window.scrollTo(0, 0);
                    if (insurViewWarningMsg) {
                        ignoreInsurviewWarning = true;
                    } else {
                        ignoreInsurviewWarning = false;
                    }
                    setInsurViewWarningMsg(true);
                }
                if (ignoreInsurviewWarning === true) {
                    if (!nextStepVisited && !calledFromPopUp) {
                        return submissionVM;
                    }
                    goNext();
                }
            } 
            finally {
                hideProgressDialog();
            }
        } else {
            if (!nextStepVisited && !calledFromPopUp) {
                return submissionVM;
            }
            goNext();
        }
        return false;
    };

    const onUpdateErrors_Ext = useCallback((val) => {
        setPriorInsuranceErrors_Ext(val);
    }, []);

    const showPriorMetSubmissionModal = () => {
        const disableButton = () => {
            return _.isUndefined(_.get(submissionVM, 'baseData.newPolicyReason_Ext.value', undefined));
        };

        const mapAvailableValues = (values) => {
            if (submissionVM.isSubmitAgent.value === true) {
                values = values.filter((reason) => reason.code !== 'purchase_direct');
            }

            return values.map((type) => {
                return {
                    code: type.code,
                    name: translator({
                        id: type.name,
                        defaultMessage: type.name
                    })
                };
            });
        };

        const newPolicyReasonHelpTextMap = {
            insuring_same_location_diff_policy_form: translator(PriorMetSubmissionPopupMessages.sameLocationPriorMetTooltipContent)
        };

        const newPolicyReasonHelpTextTitleMap = {
            insuring_same_location_diff_policy_form: translator(PriorMetSubmissionPopupMessages.sameLocationPriorMetTooltipTitle)
        };

        const overrides = {
            newPolicyReasonRadioButtons: {
                helpTextTitleMap: newPolicyReasonHelpTextTitleMap,
                helpTextMap: newPolicyReasonHelpTextMap,
                availableValues: mapAvailableValues(_.get(submissionVM, 'baseData.newPolicyReason_Ext.aspects.availableValues', [])),
                value: _.get(submissionVM, 'baseData.newPolicyReason_Ext.value')
            }
        };

        const componentProps = {
            title: translator(PriorMetSubmissionPopupMessages.priorMetPopupHeader),
            uiProps: PriorMetSubmissionPopup.pageContent,
            actionBtnLabel: platformMessages.mlContinue,
            viewModel: submissionVM.baseData,
            disableButton: disableButton,
            modalBodyStyles: PriorMetSubmissionPopupStyles,
            overrideProps: overrides,
            onSaveAction: (() => {
                saveAndQuote(true);
                return true;
            }),
            showXCloseButton: false
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };
    const checkReadOnlyAnswer = (key) => {
        return false;
    };

    const [insurViewWarningMsg, setInsurViewWarningMsg] = useState(false);

    const nextStepText_Ext = () => {
        return (
            <FormattedMessage
                {...messages.continueText}
                values={{
                    quote: (
                        <strong>{translator(messages.quote)}</strong>
                    )
                }}
            />
        );
    };

    const onNext = async () => {
        const shouldValid = isComponentValid === null ? isQnb : isComponentValid
        if (!shouldValid) {
            setShowErrors(true);
            setErrorTimestamp(errorTimestamp + 1);
            return false;
        }

        if (
            recentlyAddedClaim &&
            Object.keys(recentlyAddedClaim).length > 0 &&
            (
                recentlyAddedClaim?.aspects?.valid === false ||
                recentlyAddedClaim?.aspects?.subtreeValid === false
            )
        ) {
            setShowErrors(true);
            setErrorTimestamp(prev => prev + 1);
            return false;
        }

        if (priorInsuranceErrors_Ext.length !== 0) {
            setShowPriorInsuranceErrors_Ext(true);
            return false;
        }

        if (isPriorInsuranceMetOrFarmers()) {
            showPriorMetSubmissionModal();
            return false;
        }
        return saveAndQuote();
    };

    const resolvers = {
        resolveComponentMap: {
            priorinsurancecomponent: PriorInsuranceComponent,
            questionset: QuestionSetComponent
        },
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onNext,
            onAddClaim,
            onCancelAddClaim,
            onSaveClaim,
            onDeleteClaim
        }
    };

    const generateAllDisclsuresOverrides = () => {
        const getTypeKeyDescription = (typeKeyName) => {
            return translator({
                id: typeKeyName,
                defaultMessage: typeKeyName
            });
        };

        const showName = showNameField();

        const overrides = hoModel.coverables.disclosures_ML.losses.map((disc, index) => {
            return {
                [`dateCell${index}`]: {
                    content: getFormattedDateString(disc.date)
                },
                [`dateCellStatus${index}`]: {
                    visible: isCustomerDisclosure(disc)
                },
                [`nameCellContent${index}`]: {
                    visible: showName
                },
                [`nameCell${index}`]: {
                    visible: showName,
                    content: _.isUndefined(disc.nameInsured) ? '' : getFullName(disc.nameInsured).toUpperCase()
                },
                [`typeCell${index}`]: {
                    content: getTypeKeyDescription(LOSSTYPE_DESCRIPTION_TYPELIST.getCode(disc.type).name)
                },
                [`amountPaidCell${index}`]: {
                    content: disc.paidAmount ? `$${disc.paidAmount.amount}` : ''
                },
                [`actionCell${index}`]: {
                    visible: isCustomerDisclosure(disc)
                }
            };
        });

        return Object.assign({}, ...overrides);
    };
    
    const overrideProps = {
        priorInsuranceComponent: {
            submissionVM: submissionVM,
            updateWizardData: updateWizardData,
            onValidate: onValidate,
            onUpdateErrors: onUpdateErrors_Ext,
            syncQuestionSets: syncPriorInsuranceQuestionSets,
            showPriorInsuranceErrors: showPriorInsuranceErrors_Ext,
            updateShowPriorInsuranceErrors: setShowPriorInsuranceErrors_Ext,
            showErrors,
            isGpa: false
        },
        dwellingQuestionSet: {
            value: filteredDwellingInfoQuestionSetData,
            onValueChange: onDwellingQuestionValueChange,
            onBlur: onBlurDwelling,
            onValidate,
            showErrors,
            checkReadOnlyAnswer
        },
        showClaimButton: {
            visible: showClaimButton,
            className: isQnb ? 'showClaimButton secondaryButton widthSmall' : 'showClaimButton',
            content: isQnb ? convertToSentenceCase(translator(messages.addClaim)) : translator(messages.addClaim)
        },
        addClaimTopContainer: {
            visible: !showClaimButton
        },
        addClaimDate: {
            value: _.get(recentlyAddedClaim, 'date.value'),
            onValueChange: (value) => {
                const updatedClaim = _.clone(recentlyAddedClaim);
                updatedClaim.date.value = value;
                setRecentlyAddedClaim(updatedClaim);
            },
            showErrors,
            className: isQnb ? 'addClaimRowInputWidth' : ''
        },
        addClaimType: {
            availableValues: formatAvailableValues(recentlyAddedClaim.type),
            value: _.get(recentlyAddedClaim, 'type.value'),
            onValueChange: (value) => {
                const updatedClaim = _.clone(recentlyAddedClaim);
                updatedClaim.type.value = value;
                setRecentlyAddedClaim(updatedClaim);
            },
            showErrors,
            className: isQnb ? 'addClaimRowInputWidth addClaimTypeMargin no-label-top-spacing' : 'no-label-top-spacing'
        },
        addClaimAmountPaid: {
            showFractions: false,
            value: _.get(recentlyAddedClaim, 'paidAmount.amount.value'),
            onValueChange: (value) => {
                const updatedClaim = _.clone(recentlyAddedClaim);
                updatedClaim.paidAmount.amount.value = value;
                setRecentlyAddedClaim(updatedClaim);
            },
            showErrors
        },
        showDisclosure: {
            visible: hoModel.coverables.disclosures_ML.losses.length > 0
        },
        showDisclosureDescription: {
            content: isPrefillDisclosures
                ? translator(messages.prefillDisclosureMessage)
                : translator(messages.manualDisclosureMessage)
        },
        showDisclosureTooltipContainer: {
            visible: isPrefillDisclosures
        },
        allDisclosuresIterable: {
            data: hoModel.coverables.disclosures_ML.losses
        },
        nameCellHeader: {
            visible: showNameField()
        },
        saveClaimButton: {
            className: isQnb ? "accentButton widthSmall" : ""
        },
        cancelClaimButton: {
            className: isQnb ? "secondaryButton widthSmall" : ""
        },
        nextDescription: {
            content: nextStepText_Ext()
        },
        actionRow: {
            className: isQnb ? "" : "col-md-12"
        },
        
        ...generateAllDisclsuresOverrides(),
    };

    const skipOnResumeIf = () => {
        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === currentStep.mlStepName) {
            return false;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
            submissionVM.hvqQuoteID_ML.value &&
            submissionVM.isBundle_ML.value) {
            return true;
        }

        if (submissionVM.value.isBundle_ML
            && submissionVM.value.baseData.status_ML !== 'Draft') {
            return true;
        }

        return true;
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited()}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={nextStepText_Ext()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={recentlyAddedClaim}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

HOAdditionalInfoToQuote.propTypes = wizardProps;

export default HOAdditionalInfoToQuote;
